import { ReferenceQuestion } from './ReferenceQuestion';

(function(){
  window.addEventListener('DOMContentLoaded', function(e){
    const elm = document.querySelector('.js-post-reference-question');

    if (elm) { new ReferenceQuestion(elm); };
  });
})();
